import { IsPremiumUser, LocationMediator } from 'shared/vidio_helpers';
import LocationAdapter from 'shared/location_adapter';

export default class HeaderMenuCategory  {
  constructor({ element }) {
    this.element = element;
    this.premierPath = this.element.dataset.premierPath;
  }

  init() {
    if (this.isRedirectToPremierHomepage()) {
      this.redirectToPremierHomepage();
    }
    if (this.isUpdateMenuBar()) {
      this.hidePremierCategory();
      this.updateVidioLogoLink();
    }
  }

  redirectToPremierHomepage() {
    LocationAdapter.href(this.premierPath + LocationMediator.search());
  }

  hidePremierCategory() {
    let premierLink = this.element.querySelector('.header-category__item a[href="' + this.premierPath + '"]');
    if (premierLink) {
      premierLink.parentNode.classList.add('hide');
    }
  }

  updateVidioLogoLink() {
    let logoLink = document.querySelector('.site-header__logo .vidio-logo__link');
    if (logoLink) {
      logoLink.setAttribute('href', this.premierPath);
    }
  }

  isRedirectToPremierHomepage() {
    return IsPremiumUser.get() && this.isHomepage();
  }

  isHomepage() {
    return LocationMediator.pathname() == "/"
  }

  isUpdateMenuBar() {
    return IsPremiumUser.get();
  }
}
